import React, { Component } from 'react';
import { arrayOf, func, number, object, string } from 'prop-types';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';

import FilterPlain from '../FilterPlain/FilterPlain';
import NumberRangeFilterForm from '../NumberRangeFilterForm/NumberRangeFilterForm';

import css from './NumberRangeFilterPlain.module.css';

class NumberRangeFilterPlainComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: true };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit(values) {
    const { onSubmit, urlQueryParams } = this.props;

    onSubmit({
      ...urlQueryParams,
      minValue: values.minValue,
      maxValue: values.maxValue,
    });
  }

  handleChange(values) {
    // For liveEdit, we use handleSubmit to apply changes immediately
    this.handleSubmit(values);
  }

  handleClear() {
    const { onSubmit, urlQueryParams } = this.props;

    onSubmit({
      ...urlQueryParams,
      minValue: null,
      maxValue: null,
    });
  }

  handleCancel() {
    const { onSubmit, initialValues } = this.props;

    onSubmit(initialValues);
  }

  render() {
    const {
      rootClassName,
      className,
      id,
      label,
      queryParamNames,
      initialValues,
      min,
      max,
      step,
      intl,
      ...rest
    } = this.props;
    const { minValue, maxValue } = initialValues || {};

    const hasValue = value => value != null;
    const hasInitialValues = initialValues && hasValue(minValue) && hasValue(maxValue);

    const labelForPlain = hasInitialValues
      ? intl.formatMessage(
          { id: 'NumberRangeFilterPlain.labelSelectedPlain' },
          {
            minValue,
            maxValue,
          }
        )
      : label;

    const labelForPopup = hasInitialValues
      ? intl.formatMessage(
          { id: 'NumberRangeFilterPlain.labelSelectedPopup' },
          {
            minValue,
            maxValue,
          }
        )
      : label;

    const classes = classNames(rootClassName || css.root, className);

    return (
      <FilterPlain
        className={classes}
        rootClassName={rootClassName}
        label={labelForPlain}
        isSelected={hasInitialValues}
        id={`${id}.plain`}
        liveEdit
        contentPlaceholderText={labelForPopup}
        {...rest}
      >
        <NumberRangeFilterForm
          id={id}
          initialValues={initialValues}
          onClear={this.handleClear}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
          onChange={this.handleChange}
          intl={intl}
          contentRef={node => {
            this.filterContent = node;
          }}
          min={min}
          max={max}
          step={step}
          liveEdit
          isOpen={this.state.isOpen}
        />
      </FilterPlain>
    );
  }
}

NumberRangeFilterPlainComponent.defaultProps = {
  rootClassName: null,
  className: null,
  initialValues: null,
  step: 1,
};

NumberRangeFilterPlainComponent.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: string.isRequired,
  queryParamNames: arrayOf(string).isRequired,
  onSubmit: func.isRequired,
  initialValues: object,
  min: number.isRequired,
  max: number.isRequired,
  step: number,

  // form injectIntl
  intl: intlShape.isRequired,
};

const NumberRangeFilterPlain = injectIntl(NumberRangeFilterPlainComponent);

export default NumberRangeFilterPlain;
